<script>
// 以前的代码注释，备用观察一段时间
/* <template>
        <span v-if="!value && value!==0 && value!==false" class="readText-span">{{noValueSymbol}}</span>
        <span v-else-if="!isLongText" style="display: block;" class="readText-span" :class="{'white-space':whiteSpace, 'line-through': lineThrough}">
            {{value | formatFilter(type,format,symbol)}}
        </span>
        <span v-else-if="isLongText" :title="titleFormat" style="display: block;"
            :class="{'white-space':whiteSpace, 'line-through': lineThrough}" class="readText-span ellipsis">
            {{value | formatFilter(type,format,symbol)}}
        </span>
    </template> */
import { filter } from '../../filter/index.js'
export default {
  name: 'readText',
  functional: true,
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    whiteSpace: {
      // 是否显示空格
      type: Boolean,
      default: false,
    },
    value: null,
    type: '',
    format: '',
    symbol: '',
    isLongText: {
      type: Boolean,
      default: false,
    },
    title: {
      type: Boolean,
      default: false,
    },
    // 当值不存在的时候用符号("-")代替
    noValueSymbol: {
      type: String,
      default: '-',
    },
    // 是否显示穿过文本的线
    lineThrough: {
      type: Boolean,
      default: false,
    },
    isShowCode: {
      // 是否显示code
      type: String,
      default: '',
    },
    otherStyle: Object,
    // #7983 空值处理，如果清除为空，则上传 0；如果是 0 则显示为 空
    empty: { type: Boolean, default: false },
  },
  /* computed: {
          titleFormat () {
            if (this.type && this.format && this.symbol) {
              return filter(this.value, this.type, this.format, this.symbol);
            }
          }
        }, */
  render(h, context) {
    const { value, noValueSymbol } = context.props
    let sVnode, cData
    if (!value && value !== 0 && value !== false) {
      cData = Object.assign({ class: { 'readText-span': true } }, context.data)
      sVnode = h('span', cData, [noValueSymbol])
    } else {
      const {
        isLongText,
        title,
        whiteSpace,
        lineThrough,
        type,
        format,
        symbol,
        isShowCode,
        otherStyle,
        empty,
      } = context.props
      let fValue = type ? filter(value, type, format, symbol) || '-' : value
      if (empty && (fValue == 0 || fValue == '0')) fValue = '-'
      if (isShowCode) {
        fValue = '(' + isShowCode + ')' + fValue
      }
      cData = Object.assign(
        {
          class: {
            'readText-span': true,
            notwrap: isLongText,
            'white-space': whiteSpace,
            'line-through': lineThrough,
          },
          style: { display: 'block' },
          attrs: {
            title: isLongText || title ? fValue : '',
          },
        },
        context.data
      )
      if (!cData.attrs.title) {
        // 增加title属性
        cData.attrs.title = isLongText || title ? fValue : ''
      }
      if (otherStyle) {
        cData.style = Object.assign(cData.style || {}, otherStyle)
      }
      sVnode = h('span', cData, [fValue])
    }
    return sVnode
  },
}
</script>
